import { Component, Input, EventEmitter, Output, ElementRef, Renderer } from '@angular/core';
import { HelperMyRadiant } from '@providers/index';
import { Events, Nav, DomController, Platform } from 'ionic-angular';
import { TabsPage } from '@pages/dashboard';

/**
 * Generated class for the TreeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'cmp-drawer-vertical',
  templateUrl: 'cmp.html'
})
export class drawerVerticalCmp {

  @Input('options') options: any;

  handleHeight: number = 50;
  bounceBack: boolean = true;
  thresholdTop: number = 200;
  thresholdBottom: number = 200;
  sizeHeight : number = (this.platform.height() / 2) - 50;

  constructor(public element: ElementRef, public renderer: Renderer, public domCtrl: DomController, public platform: Platform) {

  }

  ngAfterViewInit() {

    if(this.options.handleHeight){
      this.handleHeight = this.options.handleHeight;
    }

    if(this.options.bounceBack){
      this.bounceBack = this.options.bounceBack;
    }

    // if(this.options.bounceBack){
    //   this.bounceBack = this.options.bounceBack;
    // }

    if(this.options.thresholdFromBottom){
      this.thresholdBottom = this.options.thresholdFromBottom;
    }

    if(this.options.thresholdFromTop){
      this.thresholdTop = this.options.thresholdFromTop;
    }
    console.log("platform height ->" + this.platform.height());
    this.renderer.setElementStyle(this.element.nativeElement, 'top', this.platform.height() - this.sizeHeight + 'px');
    this.renderer.setElementStyle(this.element.nativeElement, 'padding-top','0px');

    let hammer = new window['Hammer'](this.element.nativeElement);
    hammer.get('pan').set({ direction: window['Hammer'].DIRECTION_VERTICAL });

    hammer.on('pan', (ev) => {
      // this.handlePan(ev);
      console.log("ev",ev);
      if (ev.target.classList.contains("enable-pan")) {
        this.handlePan(ev);
      }else{
        // this.handlePan(ev);
      }
    });

  }

  handlePan(ev){

    let newTop = ev.center.y;

    let bounceToBottom = false;
    let bounceToTop = false;

    if(this.bounceBack && ev.isFinal){

      let topDiff = newTop - this.thresholdTop;
      let bottomDiff = (this.platform.height() - this.thresholdBottom) - newTop;      

      topDiff >= bottomDiff ? bounceToBottom = true : bounceToTop = true;

    }
    if(ev.additionalEvent === "panup"){
      this.domCtrl.write(() => {
        this.renderer.setElementStyle(this.element.nativeElement, 'transition', 'top 0.5s');
        this.renderer.setElementStyle(this.element.nativeElement, 'top', '50px');
      });
      if (this.options.has_event_panup) {
        this.options.event_panup();
      }
    }else{
      // ev.additionalEvent === "pandown"
      this.domCtrl.write(() => {
        this.renderer.setElementStyle(this.element.nativeElement, 'transition', 'top 0.5s');
        this.renderer.setElementStyle(this.element.nativeElement, 'top', this.platform.height() - this.sizeHeight + 'px');
      });
      if (this.options.has_event_pandown) {
        this.options.event_pandown();
      }
    }
    // if((newTop < this.thresholdTop && ev.additionalEvent === "panup") || bounceToTop){
    //   //drag ke atas
    //   console.log("DRAG KEATAS 1");
    //   this.domCtrl.write(() => {
    //     this.renderer.setElementStyle(this.element.nativeElement, 'transition', 'top 0.5s');
    //     this.renderer.setElementStyle(this.element.nativeElement, 'top', '50px');
    //   });

    // } else if(((this.platform.height() - newTop) < this.thresholdBottom && ev.additionalEvent === "pandown") || bounceToBottom){
    //   //ketika drag kebawah
    //   console.log("DRAG KEBAWAH 1");
    //   this.domCtrl.write(() => {
    //     this.renderer.setElementStyle(this.element.nativeElement, 'transition', 'top 0.5s');
    //     this.renderer.setElementStyle(this.element.nativeElement, 'top', this.platform.height() - this.sizeHeight + 'px');
    //   });

    // } else {
    //   bounceToTop = false;
    //   console.log("DRAG CUSTOM",ev);
    //   this.renderer.setElementStyle(this.element.nativeElement, 'transition', 'none');
     
    //   // if(newTop > 0 && newTop < (this.platform.height() - this.sizeHeight)) {

    //   //   if(ev.additionalEvent === "panup" || ev.additionalEvent === "pandown"){

    //   //     this.domCtrl.write(() => {
    //   //       this.renderer.setElementStyle(this.element.nativeElement, 'top', newTop + 'px');
    //   //     });

    //   //   }

    //   // }

    // }

  }
}



// WEBPACK FOOTER //
// ./src/components/Content/drawer_vertical/cmp.ts